export const ID32 = () => {
    return (
        <div>
            <div className="content" readonly="">
                <h1>1С:Бухгалтерия строительной организации для Казахстана</h1>

                <h2>О продукте</h2>
                <p>
                    В Казахстане в последние годы развитие строительного бизнеса развивается стремительно. Большое
                    влияние оказывает технологический бум в области автоматизации
                    бизнес-процессов, которые направлены на выстраивание модели взаимоотношений между человеком и
                    технологиями. Бизнес в современном мире стремится к снижению
                    любых рисков, влияющих на работу компании. Одним из методов оценки бизнесом является получение
                    достоверного финансового результата, который может быть
                    получен с помощью автоматизации процессов. При выявление проблем в строительной отрасли, одними из
                    основных являются:
                </p>

                <ul>
                    <li>
                        <p>большой объем ручного труда,&nbsp;</p>
                    </li>
                    <li>
                        <p>бумажных носителей,&nbsp;</p>
                    </li>
                    <li>
                        <p>контроль исполнения,&nbsp;</p>
                    </li>
                    <li>
                        <p>&nbsp;долгий процесс принятия решений,</p>
                    </li>
                    <li>
                        <p>&nbsp;рациональное распределения бюджета.</p>
                    </li>
                </ul>

                <p>
                    Чтобы избежать возможных рисков, связанных с финансированием, строительным компаниям необходимо
                    подстраиваться под современные реалии рынка,
                    автоматизировать максимально свои бизнес-процессы. 1С:Бухгалтерия строительной организации для
                    Казахстана - программный продукт, который является помощником
                    в вопросе автоматизации для строительных компаний. Он предназначен для автоматизации оперативного,
                    бухгалтерского и налогового учета. Программный продукт
                    поможет в решении таких задач:
                </p>

                <ul>
                    <li>получение&nbsp; достоверной информации о производственных и финансовых результатах деятельности
                        организации;
                    </li>
                    <li>осуществление контроля за произведенные расчетные операции, а также за остатками денежных
                        средств на расчетном счете и в кассе;
                    </li>
                    <li>осуществление контроля за дебиторской и кредиторской задолженностью;;</li>
                    <li>осуществление мониторинга 24/7.</li>
                </ul>

                <p>
                    Совокупность аналитических показателей позволяет своевременно проводить корректирующие и
                    предупреждающие действия в управлении предприятия. Программный
                    продукт является комплексным решением, включающим управление строительным процессом, электронным
                    документооборотом, созданием смет, строительный контроль. С
                    помощью 1С:Бухгалтерия строительной организации для Казахстана все участники строительного процесса
                    будут иметь актуальную информацию об остатках
                    материалов, состояниях взаиморасчетах, затратах на объекты строительства.
                </p>

                <p>Преимуществом программного продукта, является хранение большого объема информации. Он позволяет
                    объединить различные отделы в единое информационное поле:</p>

                <ul>
                    <li>Производственно-технический отдел;</li>
                    <li>Сметно-договорной отдел;</li>
                    <li>Бухгалтерия;</li>
                    <li>Кладовщики;</li>
                    <li>Табельщики;</li>
                    <li>Мастера и начальники участков;</li>
                    <li>Транспортный отдел, диспетчер.</li>
                </ul>

                <p>
                    Таким образом, управление проектами строительства сокращает ошибки, повышает эффективность работы
                    персонала и обеспечивает завершение проекта в срок с
                    установленным бюджетом объектов. 1С:Бухгалтерия строительной организации для Казахстана -
                    единственное типовое тиражное решение в Казахстане для детального
                    учета СМР.
                </p>

                <p>
                    В программном продукте 1С:Бухгалтерия строительной организации для Казахстана, предусмотрены
                    инструменты, которые помогают улучшить работу сотрудников и
                    администрации, повысить результативность деятельности компании, автоматизировать необходимые бизнес
                    процессы.
                </p></div>
        </div>
    )
}